export default class EVMRpc {
    connection;
    address = '';
    constructor(connection) {
        this.connection = connection;
    }
    async request(payload) {
        const data = (await this.connection.post('', payload)).data;
        if (data.error) {
            return Promise.reject(data.error);
        }
        return data.result;
    }
    rpcRequest(method, ...params) {
        return this.connection.post('', {
            method,
            params,
        });
    }
    getAddressFromDID(did) {
        return this.request({
            method: 'particle_did_getAddress',
            params: [did],
        });
    }
    getDIDFromAddress(address) {
        return this.request({
            method: 'particle_did_getDID',
            params: [address],
        });
    }
    // getPrice
    async getPrice(addressList, currency, chainId) {
        let res = (await this.connection.post('', {
            method: 'particle_getPrice',
            params: [addressList, currency],
            chainId,
        }));
        if (res.data.error) {
            console.log('getPrice error: ', res.data.error.message);
            return {
                data: {
                    result: [
                        {
                            address: 'native',
                            currencies: [
                                {
                                    type: 'usd',
                                    price: 0,
                                    marketCap: 0,
                                    '24hChange': 0,
                                    '24hVol': 0,
                                },
                            ],
                        },
                    ],
                },
            };
        }
        return res;
    }
    async getTokensAndNFTs(address, tokenAddressList = [], smartAccount, chainId) {
        const fns = [
            this.connection.post('', {
                method: 'particle_getTokensAndNFTs',
                params: [address, tokenAddressList],
                chainId,
            }),
        ];
        // const { name } = await smartAccount.getAccountConfig();
        if (chainId === Number(process.env.NEXT_PUBLIC_PURCHASE_NFT_CHAIN)) {
            fns.push(this.getNFTsByNFTAddressAndTokenIds([address, [[process.env.NEXT_PUBLIC_PURCHASE_NFT_ADDRESS, 1]]]));
        }
        // else if (name === 'UNIVERSAL') {
        //   fns.push(this.getNFTsByNFTAddressAndTokenIds([address, [[NFT_CONTRACT_ADDRESS?.[chainId || 0] ?? process.env.NEXT_PUBLIC_PURCHASE_NFT_ADDRESS, 1]]]));
        // }
        let resList = await Promise.all(fns);
        let res = resList[0];
        try {
            if (!res?.data?.result?.nfts) {
                if (!res.data.result) {
                    res.data.result = {};
                }
                res.data.result.nfts = [];
            }
            if (resList?.[1]?.length) {
                res.data.result.nfts = resList[1].concat(res.data.result.nfts);
            }
        }
        catch (error) {
            console.log('getTokensAndNFTs error: ', error);
        }
        if (res.error) {
            throw new Error(res.error);
        }
        return res;
    }
    async getTransactionsList(address, flag = false) {
        let res = await this.rpcRequest('particle_getTransactionsByAddress', address, flag);
        if (res.error) {
            throw new Error(res.error);
        }
        return res;
    }
    async getTokensByTokenAddresses(address, tokens, chainId) {
        tokens = tokens.map((tokenAddress) => {
            if (tokenAddress?.toLowerCase?.() == 'native') {
                return '1';
            }
            return tokenAddress;
        });
        let res = (await this.connection.post('', {
            method: 'particle_getTokensByTokenAddresses',
            params: [address, tokens],
            chainId,
        }));
        if (res.error) {
            throw new Error(res.error);
        }
        return res.data.result;
    }
    // get particle_suggestedGasFees
    async getSuggestedGasFees() {
        let res = await this.rpcRequest('particle_suggestedGasFees');
        if (res.error) {
            throw new Error(res.error);
        }
        return res.data.result;
    }
    // get eth_estimateGas
    async getEstimateGas(params) {
        let res = await this.rpcRequest('eth_estimateGas', params);
        if (res.error || res.data.error) {
            throw new Error(res?.error || res.data?.error?.message);
        }
        return res.data.result;
    }
    /**
     *
     * @param contractAddress
     * @param functionName erc20_transfer | erc20_approve | erc20_transferFrom erc721_safeTransferFrom erc1155_safeTransferFrom or custom_{methodName}
     * @param params
     * @returns
     */
    async abiEncodeFunctionCall(contractAddress, functionName, params) {
        let res = await this.rpcRequest('particle_abi_encodeFunctionCall', contractAddress, functionName, params);
        if (res.error || res?.data?.error) {
            throw new Error(res.error || res?.data?.error?.data?.extraMessage);
        }
        return res.data.result;
    }
    // SWAP_getQuote
    async getQuote(address, params) {
        const { amount, inputMint: fromTokenAddress, outputMint: toTokenAddress, version } = params;
        let res = await this.rpcRequest('particle_swap_getQuote', address, {
            amount,
            fromTokenAddress,
            toTokenAddress,
            provider: 'all',
            version,
        });
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    // particle_swap_checkApprove
    async swapCheckApprove(address, params) {
        let res = await this.rpcRequest('particle_swap_checkApprove', address, params);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    async swapCreateOrder(address, params) {
        let res = await this.rpcRequest('particle_swap_createOrder', address, params);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    /**
     *
     * @param address
     * @param params
     * @returns
     */
    async swapSubmitOrder(address, params) {
        let res = await this.rpcRequest('particle_swap_submitOrder', address, params);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return true;
    }
    // SWAP_getTransactions
    async getSwapTransactions(address, route) {
        let res = await this.rpcRequest('particle_swap_getSwap', address, route);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    async getTransactionReceipt(params) {
        let res = await this.rpcRequest('eth_getTransactionReceipt', params);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    async getBridgeSupportedTokens(chainId) {
        let res = await this.connection.post('', {
            method: 'particle_bridge_getTokens',
            params: [],
            chainId,
        });
        if (res.data.error) {
            throw new Error(res.data.error.message);
        }
        return res.data.result;
    }
    async bridgeCheckApprove(address, params) {
        let res = await this.rpcRequest('particle_bridge_checkApprove', address, params);
        if (res.data.error) {
            let message = res.data.error.message;
            if (res.data.error.data.extraMessage) {
                message += ': ' + res.data.error.data.extraMessage;
            }
            throw new Error(message);
        }
        return res.data.result;
    }
    async bridgeGetQuote(address, params) {
        let res = await this.rpcRequest('particle_bridge_getQuote', address, params);
        if (res.data?.error?.extraMessage || res.data?.error?.data?.extraMessage) {
            throw new Error(res.data?.error?.extraMessage || res.data?.error?.data?.extraMessage);
        }
        return res.data.result;
    }
    async bridgeStatus(params) {
        let res = await this.rpcRequest('particle_bridge_status', params);
        if (res.data.error?.message) {
            throw new Error(res.data?.error?.message);
        }
        return res.data.result;
    }
    async bridgeHistoryList(address, status) {
        let params = [address];
        if (status) {
            params.push(status);
        }
        let res = await this.connection.post('', {
            method: 'particle_bridge_history',
            params,
        });
        if (res.data.error) {
            return [];
        }
        return res.data.result;
    }
    async getBTCAccountsByAddress(params) {
        let res = await this.rpcRequest('particle_aa_getBTCAccountsByAddress', params);
        if (res.data.error) {
            return [];
        }
        return res.data.result;
    }
    async getNFTsByNFTAddressAndTokenIds(params) {
        return this.connection
            .post('', {
            method: 'particle_getNFTsByNFTAddressAndTokenIds',
            params,
            // isPublic: true,
        })
            .then((res) => {
            return res.data.result;
        });
    }
}
//# sourceMappingURL=evm-rpc.js.map